
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `"브라우저에서 열기..." 탭하기`,
's182ab2d6c997515f': `더 많은 기능과 쉬운 접근을 위해 홈 화면에 추가해주세요.`,
's224cbcec014ef6b5': `내비게이션 바에서 공유 버튼 누르기`,
's233af3b7eb5e0364': `홈에 추가`,
's37a9e8aec5713460': `더보기`,
's4c3161035f3a1413': `메뉴 누르기`,
's4e1e10a6ca408245': `"홈 화면에 추가" 탭하기`,
's6196153c4b0c1ea0': `설치`,
's633502f7cff4f847': `브라우저 메뉴 열기`,
's681e399d63311fba': `갤러리 표시`,
's6d14a4f70ba4e3cf': `공유 아이콘이 없으면 메뉴 누르기`,
's922329d6f6213590': `Dock에 추가`,
's9c63a79ffcc2a3a3': `"홈 화면에 추가" 누르기`,
'sa2d71bfd9525168d': `"Dock에 추가" 누르기`,
'sa5ef80b4bb9b39f8': `닫기`,
'sb527eca1c1d7e7be': `앱 내 브라우저 메뉴 열기`,
'sba52286c21552a4e': `더 많은 기능과 쉬운 접근을 위해 기기에 설치해주세요.`,
'sc16e00a7a8b2fde2': `뒤로`,
'scdaf4bbff76674c8': `홈 화면에 추가`,
'sd18a5b85f599ff3c': `복사한 링크를 Safari에서 열기`,
'se72fc3a84f9b51c3': `탭하여 링크 복사하기`,
'se740f75b95a51807': `더 많은 기능과 쉬운 접근을 위해 Dock에 추가해주세요.`,
'sfa6c42cdf48d93d2': `하지만 이 브라우저는 이 기능을 지원하지 않습니다. 계속하려면 외부 브라우저에서 링크를 여세요.`,
'sfb78526365796a41': `공유 메뉴에서 "더 보기" 누르기`,
'sfea652f6580ff086': `이 사이트는 앱 기능을 가지고 있습니다.`,
    };
  